/* eslint-disable no-case-declarations */
import {
  LOGINOUT_SUCCESS,
  LOGIN_START,
  LOGIN_MODAL_VISIBLE,
  LOGIN_SUCCESS,
  LOGIN_ACCOUNT_OR_PASSWORD_ERROR,
  LOGIN_TIMEOUT,
  // REGISTER,
  // GET_USER_INFO,
  GET_DEVELOPER_INFO_SUCCESS,
  GET_USER_INFO_SUCCESS,
  // APPLY_FOR_VERIFY,
  REGISTER_END,
  RESET_ERROR
} from '@openplatform/store/actionTypes/homepage'

interface IUserInfo {
  userid: string
  apptoken: string | null
  nickName: string | null
  country: string | null
  avatar: string
  loginToken: string | null
  contact: string
}

interface IDeveloperInfo {
  id: string
  email: string
  address: string
  phone: string
  name: string
  type: number
  status: number
  merchantStatus: number
}

interface IState {
  userInfo: IUserInfo
  developerInfo: IDeveloperInfo
  isLogin: boolean
  isLoginPending: boolean
  isLoginModalVisible: boolean
  isLoginAccountOrPasswordError: boolean
  isLoginTimeout: boolean
}

const initialState: any = {
  userInfo: {
    userid: '',
    apptoken: localStorage.getItem('apptoken'),
    nickName: localStorage.getItem('nickName'),
    country: localStorage.getItem('country'),
    loginToken: localStorage.getItem('loginToken'),
    avatar: '',
    contact: ''
  },
  developerInfo: {
    id: '',
    email: '',
    address: '',
    phone: '',
    name: '',
    type: 0, // 开发者类型 0:企业 1:个人 2:其他
    status: 0, // 开发者认证状态 0:未入驻 1:入驻审核中 2:入驻成功 3:审核失败 4:停止认证
    merchantStatus: 0 // 商户认证状态：0-未认证，1-已认证
  },
  isLogin: false, // 是否已登录
  isLoginPending: false, // 登录按钮Pending状态
  isLoginModalVisible: false, // 登录框是否可见
  isLoginAccountOrPasswordError: false, // 是否账号或密码错误
  isLoginTimeout: false // 是否登录超时
}

const reducer = (state = initialState, action: any) => {
  const { type, payload } = action
  switch (type) {
    case LOGIN_MODAL_VISIBLE:
      return { ...state, isLoginModalVisible: payload }
    case LOGIN_START:
      return { ...state, isLoginPending: true }
    // 登录成功
    case LOGIN_SUCCESS:
      const {
        regist_info: { country_code },
        token_info: { app_token, user_id, login_token },
        thirdparty_info: { nickname, email: contact }
      } = payload
      return {
        ...state,
        isLogin: true,
        isLoginPending: false,
        isLoginModalVisible: false,
        isLoginAccountOrPasswordError: false,
        isLoginTimeout: false,
        userInfo: {
          ...state.userInfo,
          nickName: state.userInfo.nickName || nickname,
          userid: user_id,
          apptoken: app_token,
          country: country_code?.toLocaleLowerCase() ?? state.userInfo.country,
          contact,
          loginToken: login_token
        }
      }
    // 注册成功
    case REGISTER_END:
      const { userid, apptoken, nickName: name, country, avatar, developerID, email } = payload
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          userid,
          apptoken,
          nickName: name,
          country,
          avatar
        },
        developerInfo: {
          ...state.developerInfo,
          id: developerID,
          email
        },
        isLogin: true
      }
    // 查询用户信息
    case GET_USER_INFO_SUCCESS:
      const { nickName: userName, userId, iconUrl } = payload || {}

      return {
        ...state,
        isLogin: true,
        userInfo: {
          ...state.userInfo,
          nickName: userName ?? state.userInfo.nickName,
          avatar: iconUrl,
          userid: userId
        }
      }
    // 查询开发者认证信息
    case GET_DEVELOPER_INFO_SUCCESS:
      const { contactMailbox, contactAddress, contactNumber, contactName, examineType, id, code, merchantStatus } = payload
      if ((code && code < 0) || !id) {
        // 请求失败直接返回默认 state
        return { ...state }
      }
      const { developerInfo } = state
      return {
        ...state,
        isLogin: true,
        developerInfo: {
          ...developerInfo,
          id,
          type: payload.state,
          status: examineType ?? 0,
          merchantStatus: merchantStatus ?? 0,
          email: contactMailbox,
          address: contactAddress,
          phone: contactNumber,
          name: contactName
        }
      }
    // 账号密码错误
    case LOGIN_ACCOUNT_OR_PASSWORD_ERROR:
      return {
        ...state,
        isLoginPending: false,
        isLoginAccountOrPasswordError: true,
        isLogin: false
      }
    // 登录超时
    case LOGIN_TIMEOUT:
      return {
        ...state,
        isLoginPending: false,
        isLoginAccountOrPasswordError: false,
        isLoginTimeout: true,
        isLogin: false
      }
    // 重置登录错误状态，在表单发生变化时
    case RESET_ERROR:
      return {
        ...state,
        isLoginPending: false,
        isLoginAccountOrPasswordError: false,
        isLoginTimeout: false,
        isLogin: false
      }
    // 退出登录
    case LOGINOUT_SUCCESS:
      return {
        ...state,
        isLogin: false,
        userInfo: {
          ...state.userInfo,
          userid: '',
          apptoken: '',
          nickName: '',
          country: '',
          avatar: ''
        },
        developerInfo: {
          id: '',
          email: '',
          address: '',
          phone: '',
          name: '',
          type: '',
          status: 0
        }
      }
    default:
      return state
  }
}

export default reducer
